// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Şirketler',
  subtitle: 'Tüm şirket bilgilerini yönetin',
  addNew: 'Yeni Şirket',
  edit: 'Düzenle',
  searchPlaceholder: 'Şirket ara...',
  filterAll: 'Tümü',
  filterActive: 'Aktif',
  filterInactive: 'Pasif',
  resultsFound: 'şirket bulundu',
  noCompanies: 'Henüz şirket yok',
  noCompaniesFiltered: 'Arama sonucu bulunamadı',
  noCompaniesDesc: 'Farklı arama terimleri deneyin',
  noCompaniesStart: 'İlk şirketinizi ekleyerek başlayın.',
  tableCompany: 'Şirket',
  tableContact: 'İletişim',
  tableCustomer: 'Müşteri',
  tableAddress: 'Adres',
  tableStatus: 'Durum',
  tableActions: 'İşlemler',
  statusActive: 'Aktif',
  statusInactive: 'Pasif',
  activate: 'Aktif yap',
  deactivate: 'Pasif yap',
  view: 'Görüntüle',
  delete: 'Sil',
  companyDetails: 'Şirket Detayları',
  detailName: 'Şirket Adı',
  detailEmail: 'E-posta',
  detailPhone: 'Telefon',
  detailWebsite: 'Website',
  detailTaxNumber: 'Vergi Numarası',
  detailAddress: 'Adres',
  detailDescription: 'Açıklama',
  detailRegDate: 'Kayıt Tarihi',
  close: 'Kapat',
  deleteConfirm: 'Bu şirketi silmek istediğinizden emin misiniz?',
  companyAdded: 'Şirket başarıyla eklendi',
  companyUpdated: 'Şirket başarıyla güncellendi',
  companyDeleted: 'Şirket başarıyla silindi',
  fetchError: 'Veriler alınamadı',
  addError: 'Şirket eklenemedi',
  updateError: 'Şirket güncellenemedi',
  deleteError: 'Şirket silinemedi',
  export: 'Dışa Aktar',
  operationFailed: 'İşlem başarısız',
  selectToDelete: 'Silmek için şirket seçin',
  loginRequired: 'Oturum açmanız gerekiyor',
  bulkDeleteConfirm: '{{count}} şirketi silmek istediğinizden emin misiniz?',
  sessionExpired: 'Oturum süreniz doldu. Lütfen tekrar giriş yapın.',
  bulkDeleteFailed: 'Toplu silme işlemi başarısız',
  connectionError: 'Bağlantı hatası',
  name: 'Şirket Adı',
  address: 'Adres',
  phone: 'Telefon',
  email: 'E-posta',
  website: 'Website',
  taxNumber: 'Vergi Numarası',
  description: 'Açıklama',
  latitude: 'Enlem',
  longitude: 'Boylam',
  country: 'Ülke',
  city: 'Şehir',
  sheetName: 'Şirketler',
  exportSuccess: 'Şirketler başarıyla dışa aktarıldı',
  editTitle: 'Şirket Düzenle',
  addTitle: 'Yeni Şirket Ekle',
  locationInfo: 'Konum Bilgisi',
  debugCountry: 'Ülke',
  debugState: 'Şehir',
  coordinateInfo: 'Koordinat Bilgisi',
  latitudePlaceholder: 'Örn: 41.0082',
  longitudePlaceholder: 'Örn: 28.9784',
  saving: 'Kaydediliyor...',
  update: 'Güncelle',
  add: 'Ekle',
  cancel: 'İptal',
  selectedCount: '{{count}} şirket seçildi',
  deleteSelected: 'Seçilenleri Sil',
  contact: 'İletişim',
  location: 'Konum',
  status: 'Durum',
  noSearchResults: 'Arama sonucu bulunamadı',
  notSpecified: 'Belirtilmemiş',
  detailsTitle: 'Şirket Detayları',
  createdAt: 'Oluşturulma Tarihi',
  updatedAt: 'Güncellenme Tarihi'
};
